import { twMerge } from "tailwind-merge";

// The Creator Score always reads with two decimals, so 31 and 47.53 line up in
// a ranking column instead of one looking like a rounder, different quantity.
// A non-finite value renders as a dash rather than "NaN": still visibly wrong,
// so a broken score surfaces instead of being disguised as zero.
export const formatScore = (value: number) => Number.isFinite(value) ? value.toFixed(2) : "—";

export const formatNumber = new Intl.NumberFormat("pt-BR", { notation: "compact", maximumFractionDigits: 1 }).format;

export function formatCurrency(valueInCents: number, currency = "BRL") {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency }).format(valueInCents / 100);
}

export function formatDate(value?: string | null, options: Intl.DateTimeFormatOptions = { day: "2-digit", month: "short", year: "numeric" }) {
  if (!value) return "—";
  return new Intl.DateTimeFormat("pt-BR", options).format(new Date(value));
}

export function initials(name: string) {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

export function classNames(...values: Array<string | false | null | undefined>) {
  return twMerge(values.filter(Boolean).join(" "));
}

/*
 * Reads the visitor's own clock, not the server's. The dashboard renders behind
 * ProtectedRoute, which shows its loading state during SSR, so this only ever
 * runs in the browser and cannot produce a hydration mismatch.
 *
 * The small hours greet with "Boa noite": Portuguese has no greeting for 3am,
 * and it reads better than telling someone still awake good morning.
 */
export function greetingFor(date = new Date()) {
  const hour = date.getHours();
  if (hour < 5) return "Boa noite";
  if (hour < 12) return "Bom dia";
  if (hour < 18) return "Boa tarde";
  return "Boa noite";
}
